import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png'; // Adjust path
import './Header.css';
import { NavLink } from 'react-router-dom';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleHamburger = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="header-main sticky">
    <div className="container">
      <div className="d-flex justify-content-between align-items-center d-lg-none px-3 py-2">
        <button className="ham" onClick={toggleHamburger}>
          <div className={`hamburger ${menuOpen ? 'open' : ''}`} id="hamburger-1">
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </button>
        <Link to="http://localhost:3000/" className="mobile-logo">
          <img src={logo} alt="Logo" className="w-100" />
        </Link> 
      </div>
      {/* === Side Menu (mobile only) === */}
      <ul className={`menu d-block d-lg-none ${menuOpen ? 'menu-open' : ''}`}>
        <div>
          <button className="close-btn" onClick={toggleHamburger}>&times;</button>
          <li><Link className="menuLink" to="http://localhost:3000/" onClick={toggleHamburger}>HOME</Link></li>
          <li><Link className="menuLink" to="https://webvexo.com/Webhosting" onClick={toggleHamburger}>Hosting Plans</Link></li>
          <li><Link className="menuLink" to="https://webvexo.com/Vpscloud" onClick={toggleHamburger}>VPS & Cloud</Link></li>
          <li><Link className="menuLink" to="https://webvexo.com/Dedicatedservers" onClick={toggleHamburger}>Dedicated Servers</Link></li>
          <li><Link className="menuLink" to="https://webvexo.com/SubscribeForm" onClick={toggleHamburger}>SubscribeForm</Link></li>
          <li><Link className="menuLink" to="https://webvexo.com/Emailhosting" onClick={toggleHamburger}>Email Hosting</Link></li>
        </div>
      </ul>
      {/* === Top Navbar (desktop only) === */}
      <nav className="navbar navbar-expand-lg navbar-light d-none d-lg-flex w-100">
        <Link className="navbar-brand" to="https://webvexo.com/">
          <img src={logo} className="w-100" alt="Logo" />
        </Link>

        <div className="header-menu">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink
                className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                to="https://webvexo.com/"
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                to="https://webvexo.com/Webhosting"
              >
               Hosting Plans
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                to="https://webvexo.com/Vpscloud"
              >
                VPS & Cloud
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                to="https://webvexo.com/Storage"
              >
               Storage 
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                to="https://webvexo.com/Dedicatedservers"
              >
               Dedicated Servers 
              </NavLink>
            </li>
          </ul>
        </div>
        <a href ="https://webvexo.com/ContactForm" className='insuba-btn text-center padding-quotebtn ms-auto'>Contact Us</a>
      </nav>
    </div>
    </header>
  );
};

export default Header;
